import { codeFromCodeableConcept } from '@seen/core/codeableConcept'
import { AssessmentTemplate } from '@seen/core/models/assessmentTemplate'
import { IncidentTemplate } from '@seen/core/models/incidentTemplate'
import type { ExtendedLibrary } from '@seen/core/models/library'
import { NoteTemplate } from '@seen/core/models/noteTemplate'
import { OrderTemplate } from '@seen/core/models/orderTemplate'
import { compact } from 'lodash-es'

/**
 * Template types shown in the Templates index table — an explicit allow-list,
 * NOT a deny-list, so any topic not listed here (AI Skill, Desk App, or a type
 * added later) stays hidden by default. Codes come from the canonical model
 * `libraryTopic` concepts rather than being redefined as string literals.
 */
export const ALLOWED_TEMPLATE_TYPE_CODES = compact(
  [
    AssessmentTemplate.libraryTopic,
    OrderTemplate.libraryTopic,
    NoteTemplate.libraryTopic,
    IncidentTemplate.libraryTopic,
  ].map((topic) => codeFromCodeableConcept(topic))
)

export function isAllowedTemplateType(template: ExtendedLibrary): boolean {
  return (
    !!template.topicCode &&
    ALLOWED_TEMPLATE_TYPE_CODES.includes(template.topicCode)
  )
}
